import getSelectedTableView from '../../utils/getSelectedTableView';
import unselectAll from './unselectAll';
import { action } from 'satcheljs/lib/legacy';
import { type TableQueryType } from '../../store/schema/TableQuery';

export default action('selectAll')(function selectAll() {
    // reset selection first before select all
    unselectAll();
    const tableView = getSelectedTableView();
    if (tableView.itemIds.length === tableView.totalRowsInView || tableView.tableQuery.type === 1) {
        // non-virtual select all if all item ids are loaded
        tableView.itemIds.forEach(itemId => {
            tableView.selectedItemsIds.set(itemId, true);
        });
    } else {
        // otherwise virtual select all
        tableView.isInVirtualSelectAllMode = true;
    }
});
